import { SET_BULK_PARAMS_ADVANCED, CLEAR_PARAMS_ADVANCED, SET_PARAMS_ADVANCED } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    size: 10,
    dsp_id: "",
    status: "",
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_ADVANCED:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_PARAMS_ADVANCED:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_ADVANCED:
            return {
                ...state,
                search: "",
                page: 1,
            };
        default:
            return state;
    }
}
